import { render, staticRenderFns } from "./AggregatedReports.vue?vue&type=template&id=363d5946&scoped=true"
import script from "./AggregatedReports.vue?vue&type=script&lang=js"
export * from "./AggregatedReports.vue?vue&type=script&lang=js"
import style0 from "./AggregatedReports.vue?vue&type=style&index=0&id=363d5946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363d5946",
  null
  
)

export default component.exports